import { useEffect, useState } from "react";
import { Button, Form, Input, Spin, InputNumber, message, Select, Switch, Modal } from "antd";
import styles from "../styles/Params.module.css";

import getInstance from "../../../api/Request";


const { Option } = Select;

const FormSection = ({ title, description, children }) => (
  <div className="bg-white p-6 rounded-xl border border-gray-200 mb-6 shadow-sm">
    <div className="mb-6 border-b border-gray-100 pb-4">
      <h3 className="text-lg font-semibold text-gray-800 m-0">{title}</h3>
      {description && <p className="text-sm text-gray-500 mt-1 mb-0">{description}</p>}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
      {children}
    </div>
  </div>
);

const SwitchItem = ({ label, name }) => (
  <div className="flex justify-between items-center py-2 h-full w-full">
    <span className="font-medium text-gray-700 leading-none">{label}</span>
    <Form.Item name={name} valuePropName="checked" noStyle>
      <Switch />
    </Form.Item>
  </div>
);

const ParamsUi = (props) => {
  const { loading, listparams, listbinpromos, sendParams, userId } = props;
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [paramStatus, setParamStatus] = useState({});
  const [activeTab, setActiveTab] = useState("general");

  const tabsConfig = [
    { key: "general", label: "General" },
    { key: "checkout", label: "Checkout" },
    { key: "delivery", label: "Delivery" },
    { key: "otros", label: "Otros" },
    { key: "integraciones", label: "Integraciones" }
  ];
  // Convertimos el array en initialValues para el formulario

  useEffect(() => {
    if (listparams && listparams.length > 0) {
      const initialValues = listparams.reduce((acc, curr) => {
        let isBoolean = false;
        const listboolean = ['app_guest_enable', 'app_guest_usecode', 'app_delivery_peya_enable', 'app_delivery_peya_enable', 'app_delivery_floti_enable', 'app_delivery_selft_enable', 'app_delivery_peya_test', 'app_checkout_promotion_cards', 'app_user_can_viewfavs', 'app_user_order_history_reorder', 'app_order_auto_finish', '']
        if (listboolean.includes(curr.name)) {
          isBoolean = true;
        }
        acc[curr.name] = isBoolean ? curr.value === "1" : curr.value;
        if (curr.name === 'app_driverpause_admin_notifications' || curr.name === 'app_driver_reporterror_notifications' || curr.name === 'app_checkout_promolist_cards') {
          acc[curr.name] = curr.value.split(",");
        }
        if (curr.name === 'app_survey_notification_delay') {
          acc[curr.name] = curr.value / 60 / 1000;
        }
        return acc;
      }, {});

      // Crear un objeto con el status de cada parámetro
      const statusObj = listparams.reduce((acc, curr) => {
        acc[curr.name] = curr.status === 1;
        return acc;
      }, {});

      setFormValues(initialValues);
      setParamStatus(statusObj);
      form.setFieldsValue(initialValues);
    }
  }, [listparams, form]);

  // Función para actualizar el estado cuando cambian los valores del formulario
  const handleFormValuesChange = (changedValues, allValues) => {
    setFormValues(allValues);
  };

  const handleUberToken = async () => {
    try {
      const request = await getInstance();
      const response = await request.post('/settings/set-uber-token', { userId });
      if (response.data.status === 'success') {
        form.setFieldsValue({
          integrator_uber_token: response.data.newtoken
        });
        message.success('Token de Uber procesado correctamente');
      } else {
        message.error('Error al procesar el token de Uber');
      }
    } catch (error) {
      console.error(error);
      message.error('Hubo un problema al conectar con el servidor');
    }
  };


  const handleSubmit = (values) => {
    try {
      Modal.confirm({
        title: 'Confirmar guardado',
        content: '¿Estás seguro de que deseas guardar los cambios en la configuración?',
        okText: 'Sí, guardar',
        cancelText: 'Cancelar',
        onOk: () => {
          form
            .validateFields()
            .then((values) => {
              const formatted = {
                ...values,
                app_survey_notification_delay: (values.app_survey_notification_delay * 60 * 1000),
                app_checkout_promolist_cards: values.app_checkout_promolist_cards?.join(',') || '',
                app_driverpause_admin_notifications: values.app_driverpause_admin_notifications?.join(',') || '',
                app_driver_reporterror_notifications: values.app_driver_reporterror_notifications?.join(',') || ''
              };
              console.log('Formulario formateado para envío:', formatted);
              sendParams(formatted);
            })
            .catch((err) => {
              message.error('Revisa los campos del formulario');
              console.error(err);
            });
        }
      });
    } catch (error) {
      console.error(error);
      message.error("Hubo un error al guardar los cambios");
    }
  };

  return (
    <div className={styles.wrapper}>
      <Form
        form={form}
        name="params_form"
        onFinish={handleSubmit}
        initialValues={formValues}
        layout="vertical"
        onValuesChange={handleFormValuesChange}
      >
        {!loading && listparams.length > 0 ? (
          <div className="flex gap-6 items-start">
            <div className={styles.navWrapper}>
              <Button type="primary" htmlType="submit" className={styles.submitBtnTop}>
                Guardar Cambios
              </Button>
              <div className={styles.cardsContainer}>
                {tabsConfig.map((t) => (
                  <div
                    key={t.key}
                    className={`${styles.card} ${activeTab === t.key ? styles.activeCard : ''}`}
                    onClick={() => setActiveTab(t.key)}
                  >
                    <span className="font-medium">{t.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.animatedContent} key={activeTab}>
              {activeTab === "general" && (
                <div className="w-full">
                  <FormSection title="Moneda y Finanzas" description="Configura los símbolos y cobros predeterminados">
                    {paramStatus.app_currency_symbol && (
                      <Form.Item
                        key="app_currency_symbol"
                        name="app_currency_symbol"
                        label={<p className="font-medium text-gray-700 m-0">Símbolo Moneda</p>}
                        valuePropName="value"
                      >
                        <Input placeholder="$" size="large" className="rounded-md" />
                      </Form.Item>
                    )}
                    {paramStatus.app_currency_iso && (
                      <Form.Item
                        key="app_currency_iso"
                        name="app_currency_iso"
                        label={<p className="font-medium text-gray-700 m-0">Código ISO Moneda</p>}
                        valuePropName="value"
                      >
                        <Input placeholder="USD" size="large" className="rounded-md" />
                      </Form.Item>
                    )}
                    {paramStatus.IVA && (
                      <Form.Item
                        key="IVA"
                        name="IVA"
                        label={<p className="font-medium text-gray-700 m-0">Impuesto al Valor Agregado (IVA)</p>}
                        valuePropName="value"
                      >
                        <Input placeholder="0.00" size="large" addonBefore={formValues.app_currency_symbol} className="rounded-md" />
                      </Form.Item>
                    )}
                  </FormSection>

                  <FormSection title="Visualización e Interacción" description="Ajustes sobre cómo los clientes ven la app">
                    {paramStatus.app_order_history_perpage && (
                      <Form.Item
                        key="app_order_history_perpage"
                        name="app_order_history_perpage"
                        label={<p className="font-medium text-gray-700 m-0">Historial: Órdenes por Página</p>}
                        valuePropName="value"
                      >
                        <InputNumber placeholder="1" size="large" className="rounded-md w-full" />
                      </Form.Item>
                    )}
                    {paramStatus.app_survey_notification_delay && (
                      <Form.Item
                        key="app_survey_notification_delay"
                        name="app_survey_notification_delay"
                        label={<p className="font-medium text-gray-700 m-0">Encuesta: Retardo de notificación</p>}
                        valuePropName="value"
                      >
                        <InputNumber placeholder="3" size="large" addonAfter="minutos" className="rounded-md w-full" />
                      </Form.Item>
                    )}
                  </FormSection>
                </div>
              )}

              {activeTab === "checkout" && (
                <div className="w-full">
                  <FormSection title="Configuración de Compra" description="Reglas generales aplicables al carrito y checkout">
                    {paramStatus.app_order_minimun && (
                      <Form.Item
                        key="app_order_minimun"
                        name="app_order_minimun"
                        label={<p className="font-medium text-gray-700 m-0">Mínimo de Compra (Delivery)</p>}
                        valuePropName="value"
                      >
                        <Input placeholder="0.00" size="large" addonBefore={formValues.app_currency_symbol} className="rounded-md" />
                      </Form.Item>
                    )}
                  </FormSection>

                  <FormSection title="Promociones Bancarias" description="Habilita descuentos con tarjetas o BINs específicos">
                    {paramStatus.app_checkout_promotion_cards && (
                      <SwitchItem 
                        label="Activar Promociones en Tarjeta" 
                        name="app_checkout_promotion_cards" 
                      />
                    )}
                    {paramStatus.app_checkout_promotion_cards && (
                      <Form.Item
                        key="app_checkout_promolist_cards"
                        name="app_checkout_promolist_cards"
                        label={<p className="font-medium text-gray-700 m-0">Promociones activas seleccionadas</p>}
                      >
                        <Select
                          mode="multiple"
                          size="large"
                          placeholder="Selecciona promociones"
                          tokenSeparators={[',']}
                          options={(listbinpromos || []).map((promo) => ({
                            label: promo.name,
                            value: promo.id
                          }))}
                        />
                      </Form.Item>
                    )}
                  </FormSection>

                  {(paramStatus.app_guest_enable && paramStatus.app_guest_usecode) && (
                    <FormSection title="Usuario Invitado" description="Permisos para usuarios no registrados en la app">
                      <SwitchItem label="Permitir finalizar compra" name="app_guest_enable" />
                      <SwitchItem label="Permitir ingresar código descuento" name="app_guest_usecode" />
                    </FormSection>
                  )}
                </div>
              )}

              {activeTab === "delivery" && (
                <div className="w-full">
                  <FormSection title="Proveedores de Envío" description="Activa o desactiva las plataformas logísticas">
                    <SwitchItem label="Envío Propio" name="app_delivery_selft_enable" />
                    <SwitchItem label="Envío por Floti" name="app_delivery_floti_enable" />
                    <SwitchItem label="Envío por PedidosYa Courier" name="app_delivery_peya_enable" />
                  </FormSection>

                  <FormSection title="Flujo del Repartidor" description="Reglas sobre cómo interactúan los repartidores con las órdenes">
                    <Form.Item
                      key="app_driver_method_finish"
                      name="app_driver_method_finish"
                      label={<p className="font-medium text-gray-700 m-0">Método de finalización de orden</p>}
                    >
                      <Select size="large">
                        <Option value="">Selecciona Método</Option>
                        <Option value="WITH_IMAGE">Por medio de Imagen</Option>
                        <Option value="WITH_CODE">Por medio de Código</Option>
                      </Select>
                    </Form.Item>
                    <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-8">
                      <Form.Item
                        key="app_driverpause_admin_notifications"
                        name="app_driverpause_admin_notifications"
                        label={<p className="font-medium text-gray-700 m-0">Notificación driver pausa (Emails)</p>}
                      >
                        <Select mode="tags" size="large" style={{ width: '100%' }} tokenSeparators={[',']} />
                      </Form.Item>
                      <Form.Item
                        key="app_driver_reporterror_notifications"
                        name="app_driver_reporterror_notifications"
                        label={<p className="font-medium text-gray-700 m-0">Notificación error app driver (Emails)</p>}
                      >
                        <Select mode="tags" size="large" style={{ width: '100%' }} tokenSeparators={[',']} />
                      </Form.Item>
                    </div>
                  </FormSection>

                  {formValues.app_delivery_selft_enable && (
                    <FormSection title="Opciones Envío Propio">
                      <Form.Item
                        key="store_driver_radius"
                        name="store_driver_radius"
                        label={<p className="font-medium text-gray-700 m-0">Radio de distancia para notificación de Tienda</p>}
                        valuePropName="value"
                      >
                        <InputNumber placeholder="1000" size="large" addonAfter="m" className="w-full rounded-md" />
                      </Form.Item>
                    </FormSection>
                  )}

                  {formValues.app_delivery_peya_enable && (
                    <FormSection title="Opciones PedidosYa Courier">
                      <SwitchItem label="Habilitar Modo Prueba (Test)" name="app_delivery_peya_test" />
                      <Form.Item
                        key="app_delivery_peya_maxamount"
                        name="app_delivery_peya_maxamount"
                        label={<p className="font-medium text-gray-700 m-0">Monto Máximo permitido para PeYa</p>}
                        valuePropName="value"
                      >
                        <Input placeholder="0.00" size="large" className="rounded-md" />
                      </Form.Item>
                    </FormSection>
                  )}
                </div>
              )}

              {activeTab === "otros" && (
                <div className="w-full">
                  <FormSection title="Preferencias de Usuario" description="Habilita funcionalidades adicionales para clientes registrados">
                    <SwitchItem label="Usuarios pueden ver sus favoritos" name="app_user_can_viewfavs" />
                    <SwitchItem label="Usuarios pueden reordenar desde historial" name="app_user_order_history_reorder" />
                  </FormSection>
                  
                  <FormSection title="Comportamiento del Sistema">
                    <SwitchItem label="La orden se auto-finaliza automáticamente" name="app_order_auto_finish" />
                  </FormSection>
                </div>
              )}

              {activeTab === "integraciones" && (
                <div className="w-full">
                  <FormSection title="Cloudflare Images" description="Conecta el bucket de imágenes para recursos multimedia">
                    <Form.Item
                      key="images_cloudflare_accountID"
                      name="images_cloudflare_accountID"
                      label={<p className="font-medium text-gray-700 m-0">Account ID</p>}
                    >
                      <Input placeholder="Account ID" size="large" className="rounded-md" />
                    </Form.Item>
                    <Form.Item
                      key="images_cloudflare_apiKey"
                      name="images_cloudflare_apiKey"
                      label={<p className="font-medium text-gray-700 m-0">API Key</p>}
                    >
                      <Input placeholder="API Key" size="large" className="rounded-md" />
                    </Form.Item>
                  </FormSection>

                  <FormSection title="Uber Direct" description="Configuración para entregas delegadas a Uber">
                    <Form.Item
                      key="integrator_uber_token"
                      name="integrator_uber_token"
                      label={<p className="font-medium text-gray-700 m-0">Token de Autenticación</p>}
                    >
                      <Input placeholder="Token" size="large" className="rounded-md" />
                    </Form.Item>
                    <Form.Item label={<span className="invisible">Acción</span>}>
                      <Button size="large" type="default" onClick={handleUberToken} className="w-full rounded-md font-medium border-gray-300">
                        Generar Nuevo Token Uber
                      </Button>
                    </Form.Item>
                  </FormSection>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.loader}>
            <Spin size="large" />
          </div>
        )}
      </Form>
    </div>
  );
};

export default ParamsUi;
